import { render } from "./liv.vue?vue&type=template&id=472ad53c"
import script from "./liv.vue?vue&type=script&lang=js"
export * from "./liv.vue?vue&type=script&lang=js"

import "./liv.vue?vue&type=style&index=0&id=472ad53c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__